import React from 'react';
import styled from 'styled-components';
import images from 'rc-images';


const MiloHandImage = styled.div`
  height: 50px;
  background-image: url(${images.searchBoxMiloHand});
  z-index: 1 !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  transform: translate(-50%, -50%);

  @media screen and (min-width: 917px) {
    width: 95px;
    left: 72%;
    top: 98%;
  }
  
  @media screen and (min-width: 867px) and (max-width: 916px) {
    width: 86px;
    left: 71%;
    top: 94%;
  }

  @media screen and (min-width: 861px) and (max-width: 866px) {
    width: 89px;
    left: 71%;
    top: 90%;
  }

  @media screen and (min-width: 810px) and (max-width: 860px) {
    width: 86px;
    left: 71%;
    top: 90%;
  }

  @media screen and (min-width: 800px) and (max-width: 809px) {
    width: 86px;
    left: 71%;
    top: 88%;
  }

  @media screen and (min-width: 768px) and (max-width: 799px) {
    width: 83px;
    left: 71%;
    top: 88%;
  }

  @media screen and (min-width: 709px) and (max-width: 767px) {
    width: 95px;
    left: 64%;
    top: 98%;
  }

  @media screen and (min-width: 656px) and (max-width: 708px) {
    width: 95px;
    left: 65%;
    top: 97%;
  }

  @media screen and (min-width: 620px) and (max-width: 655px) {
    width: 95px;
    left: 66%;
    top: 98%;
  }

  @media screen and (min-width: 566px) and (max-width: 619px) {
    width: 95px;
    left: 67%;
    top: 98%;
  }

  @media screen and (min-width: 506px) and (max-width: 565px) {
    width: 100px;
    left: 69%;
    top: 98%;
  }

  @media screen and (min-width: 481px) and (max-width: 505px) {
    width: 95px;
    left: 71%;
    top: 99%;
  }

  @media screen and (min-width: 465px) and (max-width: 480px) {
    width: 92px;
    left: 73%;
    top: 95%;
  }

  @media screen and (min-width: 436px) and (max-width: 464px) {
    width: 88px;
    left: 71%;
    top: 90%;
  }

  @media screen and (min-width: 397px) and (max-width: 435px) {
    width: 80px;
    left: 71%;
    top: 86%;
  }

  @media screen and (min-width: 358px) and (max-width: 396px) {
    width: 67px;
    left: 72%;
    top: 86%;
  }

  @media screen and (min-width: 320px) and (max-width: 357px) {
    width: 63px;
    left: 71%;
    top: 79%;
  }

  @media screen and (max-width: 319px) {
    width: 56px;
    left: 71%;
    top: 80%;
  }
`;


const MiloHand = () => (
  <MiloHandImage />
);

export default MiloHand;
